module.exports = __webpack_public_path__ + "img/2.06e7eed3.png";